import { Monitor, Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@/hooks/useTheme'
import { cn } from '@/lib/utils'

/** Cycles light → dark → system. The icon always reflects the current mode. */
export default function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme()
  const { t } = useTranslation('common')

  const next = theme === 'light' ? 'dark' : theme === 'dark' ? 'system' : 'light'
  const Icon = theme === 'dark' ? Moon : theme === 'system' ? Monitor : Sun

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={t('theme')}
      title={t('theme')}
      className={cn(
        'inline-flex h-10 w-10 items-center justify-center rounded-xl transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className
      )}
    >
      <Icon className="h-[18px] w-[18px]" />
    </button>
  )
}
